import styled from 'styled-components'

export const Container = styled.div`
    margin: 0 0.5rem 0.5rem 0.5rem;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 0.5rem;

    @media (max-width: 1730px){
        grid-template-columns: repeat(2, 1fr);
        grid-template-rows: repeat(2, 1fr);
    }

    @media (max-width: 930px){
        grid-template-columns: 1fr;
        grid-template-rows: repeat(4, 1fr);
    }

    .clickable{
        @media (min-width: 960px){
            cursor: pointer;
        }
    }
`

export const Card = styled.div`
    background: var(--colorBackgroundCardsDashboard);
    color: var(--colorFontsCardsDashboard);
    padding: 1rem 0;
    border-radius: 0.25rem;
    position: relative;
    
    display: flex;
    justify-content: center;

    min-height: 27rem;

    svg{
        position: absolute;
        top: 0.5rem;
        right: 0.5rem;
        font-size: 1.2rem;
    }

    .withoutInformations{
        align-self: center;
    }

`

export const Title = styled.p`
    font-size: 1.2rem;
    color: var(--colorFontsCardsDashboard);
    font-weight: 700;
    position: absolute;
    top: 10px;
    bottom: 0;
`